/**
 * Limpia campos de lógica mayorista/B2B que no deben mostrarse en el catálogo público.
 */
const BLISTER_ECOMMERCE_KEYS = [
  'min_order_quantity',
  'role_prices',
  'price',
  'stock',
  'discount',
  'final_price',
]

export const sanitizePublicProduct = (product) => {
  if (!product || typeof product !== 'object') return product

  const copy = { ...product }
  delete copy.is_unlisted
  delete copy.prices_visible
  delete copy.visible_in_store
  delete copy.weight_grams
  delete copy.length_cm
  delete copy.width_cm
  delete copy.height_cm

  if (Array.isArray(copy.blisters)) {
    copy.blisters = copy.blisters.map((blister) => {
      const b = { ...blister }
      BLISTER_ECOMMERCE_KEYS.forEach((key) => delete b[key])
      return b
    })
  }

  return copy
}

export const sanitizePublicProductList = (products) => {
  if (!Array.isArray(products)) return products
  return products.map(sanitizePublicProduct)
}
